import { useEnsuredContext } from '~/utilities/hooks.utility';
import { MusicPlayerBehaviourContext } from './music-player.context';

export const useMusicPlayerBehaviour = () =>
  useEnsuredContext(MusicPlayerBehaviourContext);
